export default __webpack_public_path__ + "static/media/back.aa5e9a9f.svg";